import React, { useState } from 'react';
import { Button, Modal } from 'antd';

const StartButtonWithPopup = ({ startGameEvent }) => {
    const [confirmationVisible, setConfirmationVisible] = useState(false);
  
  const handleDisplayText = () => {
    setConfirmationVisible(true);
  };

  const handleConfirmationOk = () => {
    setConfirmationVisible(false);
    console.log('START gombra kattintva!');
    startGameEvent();
  };

  const handleConfirmationCancel = () => {
    setConfirmationVisible(false);
  };

  return (
    <div style={{ textAlign: 'center', margin: '20px' }}>
      <div style={{ margin: '20px' }}>
        <Button type="primary" onClick={handleDisplayText} style={{ width: '100%' }}>
          START!
        </Button>
      </div>

      <Modal
        title="Are you sure about this?"
        open={confirmationVisible}
        onOk={handleConfirmationOk}
        onCancel={handleConfirmationCancel}
        okText="Confirm"
        cancelText="No"
      >
        <p>Are you sure you want to start the game? When you start the game, the room will be locked and no one else will be able to join. So you should really only start the game when everyone is in.</p>
      </Modal>
    </div>
  );
};

export { StartButtonWithPopup };
